import addClass from 'utils/add-class';
import transitionEnd from 'utils/transition-end';

export type Config = {
  classes?: string | string[];
  index?: number | null;
};

class Overlay {
  private readonly element: HTMLDivElement;

  constructor() {
    this.element = document.createElement('div');
    this.element.hidden = true;
    this.element.classList.add('overlay');

    document.body.appendChild(this.element);

    this.toggle = this.toggle.bind(this);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
  }

  toggle(): void {
    if (this.element.hidden) {
      this.show();
    } else {
      this.hide();
    }
  }

  show(options?: Config): void {
    if (!this.element.hidden) {
      return;
    }

    this.element.hidden = false;

    if (options) {
      if (options.classes) {
        addClass(this.element, options.classes);
      }

      if (options.index) {
        this.element.style.zIndex = options.index.toString();
      }
    }
  }

  hide(): void {
    if (this.element.hidden) {
      return;
    }

    this.element.className = 'overlay';
    this.element.hidden = true;

    transitionEnd(this.element, () => {
      if (this.element.hidden) {
        this.element.style.zIndex = '';
      }
    });
  }
}

const overlay = new Overlay();

export const { show, hide } = overlay;
